import React, { useState } from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import TextAreaInput from "../../input/TextAreaInput";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";

type PlaydateInviteRecipientRejectConfirmViewProps = {
    message?: string;
    onBack: () => void;
    onBackToDetails: () => void;
    onSubmitCancel: (message: string) => void;
    baseZIndex?: number;
    loading?: boolean;
};

const PlaydateInviteRecipientRejectConfirmView: React.FC<PlaydateInviteRecipientRejectConfirmViewProps> = ({
    message,
    onBack,
    onBackToDetails,
    onSubmitCancel,
    baseZIndex,
    loading,
}) => {
    const [cancelMessage, setCancelMessage] = useState<string>(message ?? "");

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Response Details"
            infoText="Sorry you can’t make it. Please let the host know why you’re unavailable."
            topIcon="alert"
            useSectionDivider={false}
        >
            <TextAreaInput
                message={cancelMessage}
                placeholder="(optional)"
                setMessage={setCancelMessage}
                className={styles.cancellationMessageTextArea}
            />
            <div className={styles.buttonBuffer} />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={() => onSubmitCancel(cancelMessage)}
                    hasLoadingSignal={loading}
                    className={styles.cancellationPrimaryButton}
                >
                    Confirm Response
                </ActionButton>
                <UnderlineButton onClick={onBackToDetails}>
                    Back to Invite Details
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteRecipientRejectConfirmView;
